// removed by extract-text-webpack-plugin
module.exports = {"business-layout":"business-layout","business-layout-left-menu":"business-layout-left-menu","business-layout-right-content":"business-layout-right-content"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/business/style.scss
// module id = ./components/layouts/business/style.scss
// module chunks = 0